import { render } from "./pageDelivery.vue?vue&type=template&id=c3ed1a88&scoped=true"
import script from "./pageDelivery.vue?vue&type=script&lang=js"
export * from "./pageDelivery.vue?vue&type=script&lang=js"

import "./pageDelivery.vue?vue&type=style&index=0&id=c3ed1a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ed1a88"]])

export default __exports__